/* eslint import/no-named-as-default: 0 */
/* eslint import/no-named-as-default-member: 0 */
import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import cAppeared from '../components/c-appeared';
import preloader from '../components/c-preloader';
import cookieConsentDelay from '../components/c-cookie-consent-delay';
import cOutline from '../components/c-outline';
import cSkipMain from '../components/c-skip-main';

cookieConsentDelay();
cAppeared();
cOutline();
preloader();
cSkipMain();

/**
 * Common JS functions
 */

/**
 * //TODO refactoring in case of adding another language
 * @return {{xl: number, md: number, sm: number, xs: number, lg: number, xxl: number}}
 */
export function getBreakpoints() {
  return {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  };
}

window.gridBreakPoints = getBreakpoints();

export function getBrowserInfo() {
  const ua = navigator.userAgent; let tem; let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: (tem[1] || '') };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) { return { name: 'Opera', version: tem[1] }; }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  tem = ua.match(/version\/(\d+)/i);
  if (tem != null) { M.splice(1, 1, tem[1]); }
  return {
    name: M[0],
    version: M[1],
  };
}

// eslint-disable-next-line no-unused-vars
function reloadBooking() {
  window.location.hash = '/booking/step-1';
  window.location.reload();
}

/**
 * jQuery common
 */
// eslint-disable-next-line no-shadow
(function ($) {
  function lazyImage() {
    $('.lazy-picture').each(function () {
      const $picture = $(this);
      if ($picture.visible(true) && !$picture.hasClass('lazy-picture--loaded')) {
        const $source = $picture.find('source');
        const $img = $picture.find('img');
        const dataSrc = $img.attr('data-src');
        $source.each(function () {
          const $this = $(this);
          const dataSrcset = $this.attr('data-srcset');
          $this.attr('srcset', dataSrcset);
        });
        $img.attr('src', dataSrc);
        $picture.addClass('lazy-picture--loaded');

        // if browser not support object-fit css
        if ('objectFit' in document.documentElement.style === false && $img.length && $img[0].currentStyle['object-fit']) {
          if ($picture.find('img').attr('data-ie-src').length) {
            $picture.css('backgroundImage', `url(${$picture.find('img').attr('data-ie-src')})`).addClass('c-thumbnail__compat-object-fit');
          } else {
            $picture.css('backgroundImage', `url(${$picture.find('img').attr('data-src')})`).addClass('c-thumbnail__compat-object-fit');
          }
        }
      }
    });
  }
  $(window).on('load scroll', () => {
    lazyImage();
  });
  $(document).on('click tap keydown', () => {
    setTimeout(() => {
      lazyImage();
    }, 300);
  });
  // eslint-disable-next-line no-param-reassign, consistent-return
  $.fn.overflowing = function (options, callback) {
    const self = this;
    const overflowed = [];
    const hasCallback = !!(callback && typeof callback === 'function');
    let status = false;
    this.options = options || window;
    // eslint-disable-next-line consistent-return
    this.each(function () {
      if ($.isWindow(this)) return false;
      const $this = $(this);
      const elPosition = $this.position();
      const elWidth = $this.width();
      const elHeight = $this.height();
      const parents = $this.parentsUntil(self.options);
      const $parentsTo = $(self.options);
      parents.push($parentsTo);
      for (let i = 0; i < parents.length; i++) {
        const $parent = $(parents[i]);
        if ($.isWindow($parent[0])) break;
        // eslint-disable-next-line no-bitwise
        const absPosition = !!~['absolute', 'fixed'].indexOf($parent.css('position'));
        const parentPosition = $parent.position();
        const parentWidth = $parent.width();
        const parentHeight = $parent.height();
        const parentToBottom = absPosition ? parentHeight : (parentHeight + parentPosition.top);
        const parentToRight = absPosition ? parentWidth : (parentWidth + parentPosition.left);
        if (elPosition.top < 0
          || elPosition.left < 0
          || elPosition.top > parentToBottom
          || elPosition.left > parentToRight
          || (elPosition.top + elHeight) > parentToBottom
          || (elPosition.left + elWidth) > parentToRight) {
          status = true;
          $(parents[i]).addClass('overflowed');
          overflowed.push(parents[i]);
          if (hasCallback) callback(parents[i]);
        }
      }
      if ($this.parents(self.options).hasClass('overflowed')) $this.addClass('overflowing');
    });

    if (!hasCallback) return overflowed.length > 1 ? overflowed : status;
  };
  // eslint-disable-next-line no-undef
}(jQuery));

document.addEventListener('preloader:done', () => {
  const video = document.querySelector('#heroVideo');
  const main = document.querySelector('main');
  const header = document.querySelector('header');

  // don't load hero video on mobile & tables
  if (video && $(window).width() < global.breakpoints.desktop) {
    video.classList.remove('lazy');
  }

  // eslint-disable-next-line no-new
  new LazyLoad({
    elements_selector: '.lazy',
  });

  // pagespeed hacks
  main.style.opacity = 1;
  header.style.opacity = 1;
});
